import BaseApi from './BaseApi';

class DashboardApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/dashboard';
  }
}

export default DashboardApi;
